/* Mango Ecuador - Mobile V2: sincroniza el selector de color incluso si Shopify lo reconstruye. */
(() => {
  const COLOR = /^(color|colour|colores|colors|cor|couleur|farbe)$/i;

  function setup(panel) {
    if (panel.dataset.mangoV2Observer === '1') return;
    const page = panel.closest('.product__page');
    if (!page) return;
    const buttons = panel.querySelector('[data-mango-v2-swatches]');
    const name = panel.querySelector('[data-mango-v2-color-name]');
    if (!buttons || !name) return;

    let source = null;
    let items = [];
    let scheduled = false;

    const getSource = () => {
      const options = [...page.querySelectorAll('.product__content [data-option-position]')];
      return options.find(el => {
        const label = el.querySelector('.radio__legend__label');
        const title = label?.querySelector('.radio__legend__option-name')?.textContent
          || label?.childNodes[0]?.textContent || '';
        return COLOR.test(title.trim());
      }) || page.querySelector('.product__content .product__siblings');
    };

    const getName = item => item?.value
      || item?.closest('[data-tooltip]')?.getAttribute('data-tooltip')
      || item?.getAttribute('title')
      || item?.querySelector('.visually-hidden')?.textContent?.trim() || '';

    function sync() {
      const nextSource = getSource();
      if (!nextSource) {
        panel.hidden = true;
        source = null;
        return;
      }
      const inputs = [...nextSource.querySelectorAll('input[type="radio"]')];
      const links = [...nextSource.querySelectorAll('.sibling__link')];
      const nextItems = inputs.length ? inputs : links;
      if (!nextItems.length) {
        panel.hidden = true;
        return;
      }

      /* El tema puede reemplazar todo el selector al cambiar de variante.
         Por eso la clase se aplica de nuevo al nodo que existe AHORA. */
      nextSource.classList.add('mango-v2-original-color');

      if (source !== nextSource || nextItems.length !== items.length
          || nextItems.some((item, i) => item !== items[i])) {
        source = nextSource;
        items = nextItems;
        buttons.replaceChildren();
        items.forEach((item, i) => {
          const label = item.matches('input')
            ? source.querySelector(`label[for="${CSS.escape(item.id)}"]`) : item;
          const swatch = label?.closest('tooltip-component')
            || label?.querySelector('[style*="--swatch"]') || label;
          const style = swatch ? getComputedStyle(swatch) : null;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'mango-mobile-v2__swatch';
          button.setAttribute('aria-label', getName(item) || `Color ${i + 1}`);
          if (style) {
            const color = style.getPropertyValue('--swatch').trim();
            button.style.setProperty('--mango-v2-color', color || style.backgroundColor);
            if (style.backgroundImage !== 'none') button.style.backgroundImage = style.backgroundImage;
          }
          button.addEventListener('pointerdown', event => {
            // Evita que el botón de color reciba foco y desplace la página.
            if (event.cancelable) event.preventDefault();
          });
          button.addEventListener('click', () => {
            /* Resolver el selector actual, no usar referencias a inputs eliminados. */
            sync();
            const live = items[i];
            if (live) live.click();
            requestAnimationFrame(sync);
          });
          buttons.append(button);
        });
      }
      const selected = inputs.find(input => input.checked)
        || links.find(link => link.classList.contains('sibling__link--current'))
        || items[0];
      name.textContent = getName(selected)
        || source.querySelector('[data-selected-value]')?.textContent?.trim() || '';
      buttons.querySelectorAll('button').forEach((button, i) => {
        button.setAttribute('aria-pressed', String(items[i] === selected));
      });
      panel.hidden = false;
    }

    function queueSync() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        if (panel.isConnected) sync();
      });
    }

    panel.dataset.mangoV2Observer = '1';
    sync();
    /* Vigila el contenido que Shopify vuelve a renderizar, no el panel V2. */
    const content = page.querySelector('.product__content');
    if (content) {
      new MutationObserver(queueSync).observe(content, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['checked', 'class']
      });
      content.addEventListener('change', queueSync);
    }
  }

  function init(root = document) {
    if (root.matches?.('[data-mango-mobile-v2]')) setup(root);
    root.querySelectorAll?.('[data-mango-mobile-v2]').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
